module.exports = __webpack_public_path__ + "static/media/is.6d1c68e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/is.svg
// module id = 1211
// module chunks = 39